import { Constants } from './../../shared/constants';
import { FlashMessagesService } from './../../shared/flash-messages/service/flash.messages.service';
import { Injectable } from '@angular/core';
import { Payment } from '../models/payment';
import { Observable } from 'rxjs/Observable';
import { RequestOptions, Headers, Response } from '@angular/http';
import { List } from 'immutable';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { ResponseUtilService } from '../../shared/utils/response-util.service';
import { AppAuthHttpService } from '../../http/app.auth.http.service';

@Injectable()
export class PaymentHttpService {

  private readonly eventsUrl: string = this.environment.baseUrl + '/api/events';
  private readonly paymentUrl: string = this.eventsUrl + '/payments';
  private readonly cancelUrl: string = this.eventsUrl + '/payments/cancel';

  constructor(private http: AppAuthHttpService,
              private environment: EnvironmentConfiguration,
              private responseUtilService: ResponseUtilService,
              private flashMessagesService: FlashMessagesService) {
  }

  add(payment: Payment): Observable<any> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    return this.http.post(this.paymentUrl, JSON.stringify(payment.toJS()), options)
      .catch(response => {
        return this.handleError(response);
      }).share();
  }

  update(payment: Payment): Observable<any> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    return this.http.put(this.paymentUrl, JSON.stringify(payment.toJS()), options)
      .catch(response => {
        return this.handleError(response);
      }).share();
  }

  cancelNew(payment: Payment): Observable<any> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    return this.http.post(this.cancelUrl, JSON.stringify(payment.toJS()), options)
      .catch(response => {
        return this.handleError(response);
      }).share();
  }

  cancelExisting(payment: Payment): Observable<any> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    return this.http.put(this.cancelUrl, JSON.stringify(payment.toJS()), options)
      .catch(response => {
        return this.handleError(response);
      }).share();
  }

  getPayments(eventId: number): Observable<List<Payment> | Response> {
    return this.http.get(`${this.eventsUrl}/${eventId}/payments`)
      .map(response => List<Payment>(response.json().map(element => new Payment(element))))
      .catch(response => this.responseUtilService.handleError(response))
      .share();
  }

  getLatestFinalPayment(eventId: number): Observable<Payment | Response> {
    return this.http.get(`${this.eventsUrl}/${eventId}/latestFinalPayment`)
      .map(response => {
        return this.mapPaymentResponse(response);
      })
      .catch(response => this.responseUtilService.handleError(response))
      .share();
  }

  getLatestPrepayment(eventId: number): Observable<Payment | Response> {
    return this.http.get(`${this.eventsUrl}/${eventId}/latestPrepayment`)
      .map(response => {
        return this.mapPaymentResponse(response);
      })
      .catch(errorResponse => this.responseUtilService.handleError(errorResponse))
      .share();
  }

  getFinalPaymentStatusList(eventId: number): Observable<Payment[] | Response> {
    return this.http.get(`${this.eventsUrl}/${eventId}/finalPaymentStatusList`)
      .map(response => {
        return this.mapPaymentArrayResponse(response);
      })
      .catch(response => this.responseUtilService.handleError(response))
      .share();
  }

  resendPaymentRequest(eventId: number): Observable<Response> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    return this.http.put(`${this.eventsUrl}/${eventId}/resendPaymentRequest`, null, options)
      .catch(response => {
        return this.handleError(response);
      }).share();
  }

  private handleError(response: Response): Observable<Response> {
    let result: Observable<Response>;
    const responseObject = (<Response>response).json();
    if (responseObject && (<string>responseObject.error).indexOf(Constants.AGENCY_SERVICE_ERROR_RESPONSE) !== -1) {
      this.flashMessagesService.error('MESSAGES.ERROR.AGENCY_SERVICE_ADD_REQUEST');
      result = Observable.empty();
    } else {
      result = this.responseUtilService.handleError(response);
    }
    return result;
  }

  private mapPaymentResponse(response: Response) {
    let payment: Payment = null;
    const jsonPayment = response.json();
    if (jsonPayment) {
      payment = new Payment(jsonPayment);
    }
    return payment;
  }

  private mapPaymentArrayResponse(response: Response) {
    return response.json() as Array<Payment>;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/service/payment.http.service.ts